import _ from 'lodash';
import formatStateroomsForRequest from './formatters/formatStateroomsForRequest';

const formatPriceRequest = ({
  itinerary, itineraryId, staterooms, cabinCategoryCode, rateOptionCode, cruiseLineId, passengers,
  bookingResponses,
}) => {
  let cruiseItinerary = {};
  if (itinerary) {
    cruiseItinerary = { ...itinerary };
  }

  if (itineraryId && staterooms && !itinerary) {
    cruiseItinerary = {
      itineraryDetail: {
        itineraryId,
        cruiseLine: {
          cruiseLineId,
        },
      },
      cabins: staterooms.map((s, index) => ({
        searchInput: s,
        roomIndex: index,
        selectedShipCabinCategory: index === 0 ? {
          cabinCategoryCode,
        } : null,
        selectedRateOption: index === 0 ? {
          rateOptionCode,
        } : null,
      })),
    };
  }
  let { cabins } = cruiseItinerary;
  const { itineraryDetail } = cruiseItinerary;

  // remove empty items
  cabins = cabins.filter((c) => (c));

  const pricingSearch = cabins && cabins.length
    ? cabins.map((c) => {
      let bookingReference = bookingResponses && (_.find(bookingResponses, (b) => b.roomIndex
      === c.roomIndex && b.tripSegmentId === cruiseItinerary.tripSegmentId) || {})
        .bookingReference;
      if (bookingReference === 'dummy') bookingReference = undefined;
      return {
        searchInput: formatStateroomsForRequest(c.searchInput,
          itineraryDetail.cruiseLine.cruiseLineId),
        roomIndex: c.roomIndex,
        rateOptionCode: c.selectedRateOption && c.selectedRateOption.rateOptionCode,
        cabinCategoryCode: c.selectedShipCabinCategory
          && c.selectedShipCabinCategory.cabinCategoryCode,
        cabinNumber: c.selectedShipCabin && c.selectedShipCabin.cabinNumber,
        bookingReference,
        passengersPreferences: passengers ? _.map(_.filter(passengers,
          (p) => p.roomIndex === c.roomIndex), (ps, index) => ({
          passengerIndex: index,
          packages: ps.travelerPreferences && ps.travelerPreferences.selectedPackages
              && _.map(ps.travelerPreferences.selectedPackages, (pk) => ({
                code: pk.packageCode,
                type: pk.packageTypeCode,
                nights: pk.nightCount,
              })),
          specialServices: ps.travelerPreferences && ps.travelerPreferences.selectedSpecialServices
              && _.map(ps.travelerPreferences.selectedSpecialServices, (pk) => ({
                code: pk.serviceCode,
                type: pk.serviceTypeCode,
                date: pk.selectedDate,
                years: pk.selectedYear,
              })),
          insuranceCoverage: ps.insuranceCoverage,
          cruiseTransportPreference: ps.travelerPreferences.cruiseTransportPreference
            && ps.travelerPreferences.cruiseTransportPreference.mode
            && ps.travelerPreferences.cruiseTransportPreference.cityCode
            ? ps.travelerPreferences.cruiseTransportPreference : undefined,
        })) : undefined,
      };
    })
    : [];

  return {
    itineraryId: cruiseItinerary.itineraryDetail.itineraryId,
    cruiseLineId: cruiseItinerary.itineraryDetail.cruiseLine.cruiseLineId,
    searchInputs: pricingSearch,
  };
};

export default formatPriceRequest;
